import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

export default function DetailsHeaders({ currentTab,  data  }) {
  const history = useHistory()
  const CreateTaskButton = () => {
    return <a
      className="lg_btn primary mr-2"
      data-toggle='modal'
      data-target={
        `#createTask`
      }
      style={{ cursor: 'pointer', fontSize: '18px', lineHeight: '22px' }}
    >
      <span>
        <i className="fas fa-plus mr-2"></i>
      </span>
      Create Task
    </a>
  }

  const CreateNotesButton = () => {
    return <a
      className="lg_btn primary mr-2"
      data-toggle='modal'
      data-target={
        `#createNote`
      }
      style={{ cursor: 'pointer', fontSize: '18px', lineHeight: '22px' }}
    >
      <span>
        <i className="fas fa-plus mr-2"></i>
      </span>
      Create Note
    </a>
  }
  return (
    <>
      <div className='tasks-header d-flex justify-content-between mt-4'>
        {/* <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => history.goBack()}
        >{`< Back`}</button> */}

        <div className='pppsw' >
          <div className='pd-pic'>
          <span>{data? (data.firstName? data.firstName.charAt(0):"" )+  (data.lastName? data.lastName.charAt(0):"" ) : ""}</span>
          </div>
          <div className='derifhu'>
            <div > {data? (data.firstName? data.firstName:"" )+" "+  (data.lastName? data.lastName:"" ) : ""}  <span className='ver-sep'></span>    {data && data.emailMarketing == "Active"
                ? <div id ='kwneofw' className="sub" >
                  <div className="circle">
                  </div>
                  <span> Subscribed</span>
                </div>
                :  <div id ='kwneofw' className="unsub" >
                {/* <div className="circle">
                </div> */}
                {/* <span> Unsubscribed</span> */}
              </div>} </div>
            <span>{data && data?.email !== null ? data.email : ''}</span>
            <span> { data && data?.phone !== null ? data.phone : '' }</span>

          </div>

        </div>
        {/* {
          currentTab.id === 'TASKS_TAB' && <CreateTaskButton />
        }
        {
          currentTab.id === 'NOTES_TAB' && <CreateNotesButton />
        } */}
      </div>
    </>
  )
}
